import React from 'react';
export default function GalleryItem() { return null; }
